module.exports = __webpack_public_path__ + "img/all-in-one.8378572b.svg";